import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appUserManagement]'
})
export class UserManagementDirective {
  @Input('appUserManagement') userSortArray: Array<any> = [];

  constructor(private targetElement: ElementRef) { }
  @HostListener("click")
  sortData() {
    const element = this.targetElement.nativeElement;
    const order = element.getAttribute('data-order');
    order === "desc" ? element.setAttribute("data-order", "asc") : element.setAttribute("data-order", "desc");
    if (order === "desc") {
      return this.userSortArray.sort((a, b) => (a.name > b.name) ? 1 : (a.name === b.name) ? ((a.name > b.name) ? 1 : -1) : -1);
    } else {
      return this.userSortArray.sort((a, b) => (b.name > a.name) ? 1 : (a.name === b.name) ? ((b.name > a.name) ? 1 : -1) : -1);
    }

  }

}
